import assetService from '@/services/asset.js'

const assetHandler = {
  state: {
    profileDetails: {},
    allAssets: []
  },

  mutations: {
    MUTATION_PROFILE_DETAILS (state, payload) {
      if (payload) {
        state.profileDetails = payload
      } else {
        state.profileDetails = {}
      }
    },
    MUTATION_GET_ASSETS (state, payload) {
      state.allAssets = payload.result || []
    }
  },

  actions: {
    async ACTION_DOWNLOAD_LOGO (context, obj) {
      const res = await assetService.downloadImage(obj)
      return res
    },
    async ACTION_GET_PROFILE_DETAILS (context) {
      let profile = await assetService.adminProfile()
      context.commit('MUTATION_PROFILE_DETAILS', profile)
      return profile
    },
    async ACTION_LIST_ASSET (context, obj) {
      const uploadResponse = await assetService.list(obj)
      context.commit('MUTATION_GET_ASSETS', uploadResponse)
      return uploadResponse
    }
  },
  getters: {
    getprofileDetails: state => state.profileDetails,
    getAllAssets: state => state.allAssets
  }
}

export default assetHandler
